import { render } from "./Card.vue?vue&type=template&id=5dc8ff98&scoped=true&ts=true&lang=pug"
import script from "./Card.vue?vue&type=script&setup=true&lang=ts"
export * from "./Card.vue?vue&type=script&setup=true&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=5dc8ff98&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc8ff98"]])

export default __exports__